/**
 * Pure layout helper for CollectionNode grid columns/rows.
 * displayMode values align with COLLECTION_NODE_DISPLAY_MODE in index.js.
 */

export const getCollectionGridDimensions = ({
  itemsCount = 0,
  displayMode,
  memberGridLayout,
  isSubCollection = false,
}) => {
  const layout = memberGridLayout;

  if (displayMode === "single-column" || displayMode === "sub-collections") {
    const cols = 1;
    return [cols, Math.ceil(itemsCount / cols) || 1];
  }

  let cols = Math.ceil(Math.sqrt(itemsCount));

  if (layout === "spacious") {
    if (cols > 6) {
      cols = 6;
    }
    if (itemsCount > 8) {
      cols = Math.max(cols, Math.min(6, Math.ceil(itemsCount / 4)));
    }
  } else if (layout === "compact") {
    if (cols > 6) {
      cols = Math.round(cols / 2);
    } else {
      cols = cols > 2 ? cols - 1 : cols;
    }
  } else {
    if (cols > 6) {
      cols = Math.round(cols / 2);
    } else {
      cols = cols > 2 ? cols - 1 : cols;
    }
  }

  let finalCols = itemsCount > 12 ? cols - 1 : cols;

  if (layout === "spacious") {
    finalCols = itemsCount > 20 ? Math.max(1, cols - 1) : cols;
    finalCols = Math.min(6, Math.max(1, finalCols));
  } else if (layout === "compact") {
    finalCols = Math.min(finalCols, 2);
  }

  finalCols = Math.max(1, finalCols);

  const rows = Math.ceil(itemsCount / finalCols) || 1;

  if (finalCols === 1 && isSubCollection) {
    return [finalCols + 1, rows];
  }

  return [finalCols, rows];
};
